import instance from '../../../api/axios'
import { uploadFileForm } from '../types/files'

export const uploadFile = async (fileForm: uploadFileForm): Promise<any> => {
  const formData = new FormData()
  formData.append('file', fileForm.file)
  formData.append('name', fileForm.name)
  formData.append('description', fileForm.description)
  formData.append('isPublic', fileForm.isPublic?.toString() || 'true')
  if (fileForm.folderId) {
    formData.append('folderId', fileForm.folderId)
  }
  if (fileForm.protocolId) {
    formData.append('protocolId', fileForm.protocolId)
  }
  if (fileForm.tripId) {
    formData.append('tripId', fileForm.tripId)
  }
  if (fileForm.utilityBillId) {
    formData.append('utilityBillId', fileForm.utilityBillId)
  }
  if (fileForm.incomeId) {
    formData.append('incomeId', fileForm.incomeId)
  }

  const response = await instance.post('/files', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

export default uploadFile
